import { inject } from '@angular/core';
import { AgentLinkNavigatorService } from 'AgentApp/ts/services/agent-link-navigator.service';
import * as i0 from "@angular/core";
const AGENT_HASH_PREFIX = '#/?';
export class AgentLinkInterceptDirective {
    constructor() {
        this.navigator = inject(AgentLinkNavigatorService);
    }
    onClick(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
            return;
        }
        const { target } = event;
        if (!(target instanceof Element)) {
            return;
        }
        const anchor = target.closest('a');
        if (!anchor || !anchor.href) {
            return;
        }
        let url;
        try {
            url = new URL(anchor.href, window.location.origin);
        }
        catch {
            return;
        }
        if (url.origin !== window.location.origin) {
            return;
        }
        if (this.normalizePath(url.pathname) !== this.normalizePath(window.location.pathname)) {
            return;
        }
        if (!url.hash.startsWith(AGENT_HASH_PREFIX)) {
            return;
        }
        const paramString = url.hash.slice(AGENT_HASH_PREFIX.length);
        const params = this.parseParams(paramString);
        event.preventDefault();
        this.navigator.navigateToParams(params, anchor.href);
    }
    normalizePath(path) {
        return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
    }
    parseParams(paramString) {
        const searchParams = new URLSearchParams(paramString);
        const params = {};
        searchParams.forEach((value, key) => {
            params[key] = value;
        });
        return params;
    }
}
AgentLinkInterceptDirective.ɵfac = function AgentLinkInterceptDirective_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentLinkInterceptDirective)(); };
AgentLinkInterceptDirective.ɵdir = /*@__PURE__*/ i0.ɵɵdefineDirective({ type: AgentLinkInterceptDirective, selectors: [["", "ycnAgentLinkIntercept", ""]], hostBindings: function AgentLinkInterceptDirective_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("click", function AgentLinkInterceptDirective_click_HostBindingHandler($event) { return ctx.onClick($event); });
    } } });
